//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vueQr from 'vue-qr';
export default {
  data: function data() {
    return {
      isFixedCode: false,
      isFixedgzh: false,
      isclose: false
    };
  },
  components: {
    vueQr: vueQr
  },
  methods: {
    enter: function enter() {
      this.isFixedCode = true;
    },
    isclosecode: function isclosecode() {
      if (this.isclose) {
        this.isclose = false;
      } else {
        this.isclose = true;
      }
    },
    leave: function leave() {
      this.isFixedCode = false;
    },
    entera: function entera() {
      this.isFixedgzh = true;
    },
    leavea: function leavea() {
      this.isFixedgzh = false;
    }
  }
};